class SideBarControl {
	constructor(node, dataSource, config) {
		this._classSwitchObject = this._buildClassSwitchObject();		
	}

	_buildClassSwitchObject(){
		let classSwitchObject = {};
		let classSwitchers = document.querySelectorAll('[ control-role=class-switcher]');
		for(var i = 0;i<classSwitchers.length;i++){
			let classSwitcher = classSwitchers[i];
			let classSwitchGroup = classSwitcher.getAttribute('class-switch-group');
			let classSwitchClass = classSwitcher.getAttribute('class-switch-class');
			if(classSwitchObject[classSwitchGroup] === undefined){
				classSwitchObject[classSwitchGroup] = [classSwitchClass];
			}else if(classSwitchObject[classSwitchGroup].indexOf(classSwitchClass)===-1){
				classSwitchObject[classSwitchGroup].push(classSwitchClass);
			}	
			classSwitcher.addEventListener('click', this.handleClick.bind(this));	
		}
		return classSwitchObject;
	}

	handleClick(e){

		let classWasAdded  = false;
		let classSwitchGroup = e.target.getAttribute('class-switch-group');
		let switchClass = e.target.getAttribute('class-switch-class');
		if(classSwitchGroup){
			let switchTargets = document.querySelectorAll(`[class-switch-target=${classSwitchGroup}]`);
			let switchers = document.querySelectorAll('[control-role=class-switcher]');
			for(var j =0;j<switchers.length;j++){
				let switchSwitchGroup = switchers[j].getAttribute('class-switch-group');
				if(switchSwitchGroup === classSwitchGroup){
					switchers[j].classList.remove('svg-button--on');
				}
				
			}

			for(let i=0;i<switchTargets.length;i++){
				let switchTarget = switchTargets[i];
				if(switchTarget.classList.contains(switchClass)){
					switchTarget.classList.remove(switchClass);
				}else{
					switchTarget.classList.remove(...this._classSwitchObject[classSwitchGroup]);
					switchTarget.classList.add(switchClass);
					e.target.classList.add('svg-button--on');
					classWasAdded = true;
				}
			}
			
		}

		if(!classWasAdded){
			let defaultSwitchers = document.querySelectorAll('[class-switch-default]');
			for(var i = 0;i<defaultSwitchers.length;i++){
				let switchSwitchGroup = defaultSwitchers[i].getAttribute('class-switch-group');
				if(switchSwitchGroup === classSwitchGroup){
					defaultSwitchers[i].classList.add('svg-button--on');
				}
			}

		}

		return;
}
}

export default SideBarControl;